// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1rf9Y","resendInfoText":"OnGoingPaymentBox_resendInfoText__3LxcK"};